import React from "react";
import { CaretRightOutlined } from "@ant-design/icons";
import { getDescription, getMarketExplorerText, getPackage } from "../../../utils/oneintelligence/OneIntelligenceHelper";
import { CrownIcon } from "../Insights/CrownSubscription";
import { Button } from "antd";
import { useDispatch } from "react-redux";
import { setVisibleMOKBModalSub } from "../../../store/components/Reports.slice";

const TargetSelectionItems = function ({ data, onClick = () => { }, disabled = false }) {
    const dispatch = useDispatch()
    const {
        text, textObj, description, code, descriptionObj = {}, available, name, stepEnd = false, titleClassName, style = {}, accessType, noAccess
    } = data;

    const moduleCode = getPackage();
    const withBorder = moduleCode === "whitespaces";

    const isBoldTitle = (() => {
        if (["whitespaces", "aitag"].includes(moduleCode)) {
            return "fw-600-i";
        }
        return "";
    })();

    const toDisabled = (available === false || disabled || stepEnd)

    const displayPro = accessType && noAccess
    return (
        <div
            className={`reportBuilderTargetSelectionItem${toDisabled ? " disabled" : ""} d-flex align-items-center ${withBorder ? "withBorder" : ""}`}
            value={code || name}
            onClick={() => {
                if (accessType && noAccess) {
                    dispatch(setVisibleMOKBModalSub({ visible: true }))
                    return
                }
                if (available !== false && !disabled && !stepEnd) { onClick(data); }
            }}
            style={style}
        >
            <div className="d-flex-col flex-1 gap-5p">
                <div className={`item-title ${titleClassName || ""} ${isBoldTitle}`}>
                    {getMarketExplorerText({
                        textObj, text, name
                    })}
                </div>
                {available === false && <span className="availableText">Available Soon</span>}
                {displayPro && <Button className="pro-subscribe-button" type="text" icon={<CrownIcon />} onClick={() => {
                    dispatch(setVisibleMOKBModalSub({ visible: true }))
                }}>PRO</Button>}
                <p className="item-subtitle">{getDescription(data)}</p>
            </div>
            {available !== false && !stepEnd && <CaretRightOutlined className="caret" style={{ color: "#94A3B8", ...(displayPro ? { marginTop: "7mm" } : {}) }} />}
        </div>
    );
};

export default TargetSelectionItems;
